/**
 * Thin wrapper around canvas-confetti with STRATOS brand colors and safe SSR
 * import. Everything runs client-only — if window is undefined the helpers
 * degrade to no-ops so nothing breaks during any prerender/tests.
 */
let confettiFn = null;

async function getConfetti() {
  if (typeof window === "undefined") return null;
  if (confettiFn) return confettiFn;
  try {
    const mod = await import("canvas-confetti");
    confettiFn = mod.default || mod;
  } catch {
    confettiFn = null;
  }
  return confettiFn;
}

const BRAND_COLORS = ["#00C805", "#00b004", "#ffffff", "#a3f7bf"];

export async function fireConfetti({ origin = { x: 0.5, y: 0.6 } } = {}) {
  const c = await getConfetti();
  if (!c) return;
  // Two-burst effect — one wide low sweep, one focused pop
  c({ particleCount: 90, spread: 70, origin, colors: BRAND_COLORS, scalar: 0.9 });
  setTimeout(
    () => c({ particleCount: 40, spread: 100, origin, colors: BRAND_COLORS, scalar: 0.7 }),
    180,
  );
}

export async function fireBadgeConfetti() {
  const c = await getConfetti();
  if (!c) return;
  c({
    particleCount: 60,
    startVelocity: 45,
    spread: 360,
    ticks: 80,
    origin: { x: 0.9, y: 0.9 },  // bottom-right, where sonner toasts appear
    colors: BRAND_COLORS,
    scalar: 0.8,
  });
}
